import { render, staticRenderFns } from "./RegistrationsPage.vue?vue&type=template&id=cc030c2c"
import script from "./RegistrationsPage.vue?vue&type=script&lang=js"
export * from "./RegistrationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports